import * as React from "react";

const WaterIcon = ({ color = "#111928", size }: { color?: string; size: number }) => (
  <svg width={size} height={size} viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.6171 21.7796C10.2023 21.7796 7.42407 19.2465 7.42407 16.133C7.42407 13.0662 12.8771 4.34666 13.3344 3.87766C13.4036 3.80635 13.5022 3.76466 13.6063 3.76192C13.7122 3.75863 13.8114 3.79593 13.8854 3.86285C14.386 4.31868 19.8108 13.0859 19.8108 16.133C19.8108 19.2465 17.0319 21.7796 13.6171 21.7796ZM13.6219 4.72405C12.4301 6.50623 8.18151 13.6328 8.18151 16.133C8.18151 18.8658 10.6199 21.0885 13.6165 21.0885C16.6138 21.0885 19.0521 18.8653 19.0521 16.133C19.0521 14.9783 18.104 12.5812 16.3822 9.38384C15.2583 7.29612 14.1429 5.49145 13.6219 4.72405Z"
      fill={color}
    />
    <path
      d="M13.7145 20.3058C13.5051 20.3058 13.3354 20.1511 13.3354 19.9602C13.3354 19.7693 13.5051 19.6147 13.7145 19.6147C15.7955 19.6147 17.4884 18.0711 17.4884 16.1737C17.4884 15.9828 17.6581 15.8281 17.8674 15.8281C18.0768 15.8281 18.2465 15.9828 18.2465 16.1737C18.2459 18.4523 16.213 20.3058 13.7145 20.3058Z"
      fill={color}
    />
  </svg>
);

export default WaterIcon;
